import { replace } from 'react-router-redux';
import urlFriendly from './url-friendly';

// Rules which defines incomplete collection urls
function isCompleteTagUrl(params, tag) {
    if (!params.title || params.title !== tag.title) {
        return false;
    }

    return true;
}

function isCompleteStoryUrl(params, story) {
    if (!params.title || params.title !== story.title) {
        return false;
    }

    return true;
}

export default function generateCollectionRoute(dispatch, location, params) {
    return dispatch((thunkDispatch, getState) => {
        const {
            collectionArticles: { meta = {}, error },
        } = getState();

        if (error) {
            return Promise.resolve();
        }

        const { pathname = '', search = '' } = location;

        let urlPath = '';
        let isCompleteUrl = true;

        if (meta.tag) {
            const { tag = {} } = meta;
            const tagId = tag.id;
            const tagTitle = urlFriendly(tag.title);

            isCompleteUrl = isCompleteTagUrl(params, tag);
            urlPath = `/tag/${tagId}/${tagTitle}`;
        } else if (meta.story) {
            const { story = {} } = meta;
            const storyId = story.id;
            const storyTitle = urlFriendly(story.title);

            isCompleteUrl = isCompleteStoryUrl(params, story);
            urlPath = `/emne/${storyId}/${storyTitle}`;
        }

        const newLocation = `${urlPath}${search}`;
        const oldLocation = `${pathname}${search}`;

        const isNewLocation = newLocation === oldLocation;

        if (isNewLocation || isCompleteUrl) {
            return Promise.resolve();
        }

        return thunkDispatch(replace(newLocation));
    });
}



/** WEBPACK FOOTER **
 ** ./src/utils/generate-collection-route.js
 **/